import {v2Request} from "./v2Request";

export const tencentV2Api = {
  tempToken(){
    return v2Request.post(`/ai/tencent/tempToken`)
  }
}
